import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-ai-insight-tile',
    standalone: true,
    imports: [],
    templateUrl: './ai-insight-tile.component.html',
    styleUrl: './ai-insight-tile.component.scss'
})
export class AiInsightTileComponent {
    @Input() insightTitle!: string;
    @Input() insightInfo!: string;
    @Input() insightColor?: string; // Optional
}
